module.exports = __webpack_public_path__ + "img/checkbox-unchecked.3756a17c.svg";